import {
  actionTypes,
  AvisoPublicacionActions,
  AvisoPublicacionState,
  GuardarAvisoStatus,
  PublicarAvisoStatus,
  initialState,
  ActualizarAvisoStatus,
} from './types'

const AvisoPublicacionReducer = (
  state: AvisoPublicacionState = initialState,
  action?: AvisoPublicacionActions
): AvisoPublicacionState => {
  switch (action?.type) {
    case actionTypes.SET_AVISO_DATA:
      return {
        ...state,
        avisoData: action?.payload?.avisoData,
      }
    case actionTypes.RESET_AVISO_DATA:
      return {
        ...state,
        avisoData: undefined,
      }
    case actionTypes.GUARDAR_AVISO_FETCH:
      return {
        ...state,
        guardarAvisoStatus: GuardarAvisoStatus.Loading,
        avisoData: action?.payload?.avisoData,
      }
    case actionTypes.GUARDAR_AVISO_SUCCESS:
      return {
        ...state,
        guardarAvisoStatus: GuardarAvisoStatus.Success,
        avisoId: action?.payload?.avisoId,
      }
    case actionTypes.GUARDAR_AVISO_ERROR:
      return {
        ...state,
        guardarAvisoStatus: GuardarAvisoStatus.Error,
        error: action?.payload?.error,
      }
    case actionTypes.GUARDAR_AVISO_RESET:
      return {
        ...state,
        guardarAvisoStatus: GuardarAvisoStatus.Idle,
        avisoData: undefined,
        error: undefined,
      }
    case actionTypes.PUBLICAR_AVISO_FETCH:
      return {
        ...state,
        publicarAvisoStatus: PublicarAvisoStatus.Loading,
        avisoId: action?.payload?.avisoId,
        productoId: action?.payload?.productoId,
        planPublicacionId: action?.payload?.planPublicacionId,
        paisId: action?.payload?.paisId,
      }
    case actionTypes.PUBLICAR_AVISO_SUCCESS:
      return {
        ...state,
        publicarAvisoStatus: PublicarAvisoStatus.Success,
      }
    case actionTypes.PUBLICAR_AVISO_ERROR:
      return {
        ...state,
        publicarAvisoStatus: PublicarAvisoStatus.Error,
        error: action?.payload?.error,
      }
    case actionTypes.PUBLICAR_AVISO_RESET:
      return {
        ...state,
        publicarAvisoStatus: PublicarAvisoStatus.Idle,
        avisoId: undefined,
        productoId: undefined,
        paisId: undefined,
        error: undefined,
      }
    case actionTypes.ACTUALIZAR_AVISO_FETCH:
      return {
        ...state,
        actualizarAvisoStatus: ActualizarAvisoStatus.Loading,
        avisoId: action?.payload?.avisoId,
        avisoData: action?.payload?.avisoData,
      }
    case actionTypes.ACTUALIZAR_AVISO_SUCCESS:
      return {
        ...state,
        actualizarAvisoStatus: ActualizarAvisoStatus.Success,
        avisoId: action?.payload?.avisoId,
      }
    case actionTypes.ACTUALIZAR_AVISO_ERROR:
      return {
        ...state,
        actualizarAvisoStatus: ActualizarAvisoStatus.Error,
        error: action?.payload?.error,
      }
    case actionTypes.ACTUALIZAR_AVISO_RESET:
      return {
        ...state,
        actualizarAvisoStatus: ActualizarAvisoStatus.Idle,
        avisoId: undefined,
        productoId: undefined,
        paisId: undefined,
        error: undefined,
      }
    default:
      return state
  }
}

export default AvisoPublicacionReducer
